// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zkGs","col":"styles_col__3zufj"};